import { render, staticRenderFns } from "./HomeMainLinks.vue?vue&type=template&id=ac5004c6&"
import script from "./HomeMainLinks.vue?vue&type=script&lang=js&"
export * from "./HomeMainLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports